// export const hostURL = "http://localhost:4002/";
export const hostURL = "https://api.valueloads.com/";
